import { useEffect } from 'react'

/**
 * Custom hook to prevent page scrolling when overlays are open
 *
 * @param isLocked - Whether to lock the scroll
 * @param dependencies - Additional dependencies to trigger the effect
 * @param scrollToTopOnUnlock - If true, scrolls to top when unlocking instead of restoring previous scroll position
 */
export const useScrollLock = (isLocked: boolean, dependencies: any[] = [], scrollToTopOnUnlock = false) => {
  useEffect(() => {
    if (isLocked) {
      // Store the current scroll position
      const { scrollY } = window

      // Add styles to prevent scrolling
      const style = document.createElement('style')
      style.id = 'scroll-lock-style'
      style.innerHTML = `
        body {
          position: fixed;
          top: -${scrollY}px;
          left: 0;
          right: 0;
          overflow: hidden;
        }
      `
      document.head.appendChild(style)

      // Cleanup function to restore scrolling
      return () => {
        const existingStyle = document.getElementById('scroll-lock-style')
        if (existingStyle) {
          document.head.removeChild(existingStyle)
        }

        // Restore scroll position
        const nextScrollY = scrollToTopOnUnlock ? 0 : scrollY
        window.scrollTo(0, nextScrollY)
      }
    }
    return undefined
  }, [isLocked, ...dependencies])
}
